import React, {useEffect, useMemo, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import Title from "../../../components/Title";
import FilterButton, {FilterGroup} from "../../../components/FilterButton";
import {DateRangeFilterButton} from "../../../components/DateRangeFilterButton";
import CmpAnalyticsDashboardContainer, {ConsentLayoutTab} from "../../../components/cmp/analytics/CmpAnalyticsDashboardContainer";
import {Loader} from "../../../components/components";
import useCmpAnalytics from "../../api_hooks/useCmpAnalytics";
import ConsentByAppTable from "../../../components/cmp/analytics/ConsentByAppTable";


export default function CmpAnalytics(props) {
  const { t } = useTranslation();
  const {setFilter, loaderProps, data, analytics, kpis} = useCmpAnalytics({configurable: null})

  return (
    <>
      <Title main={"CMP"} sub={"analytics"}/>
      <FilterGroup fireOnChangeAtMount={false} onChange={setFilter} >
        <DateRangeFilterButton
          startDate={data.startDate}
          endDate={data.endDate}
        />
        <FilterButton
          title={"OS"}
          options={useMemo(() => (["ios", "android"].map(os => ({label: t(os), value: os}))), [])}
          search={false}
          includeAll={true}
          name="os"/>
        <FilterButton
          title={t("cmp.analytics.tcfVersion")}
          options={[1, 2]}
          search={false}
          includeAll={true}
          name="tcf"/>
        <FilterButton
          title={"SDK"}
          options={data.sdkVersions}
          search={true}
          includeAll={true}
          name="sdk_version"/>
        <FilterButton
          title={"layout"}
          options={data.layoutVersions}
          search={true}
          includeAll={true}
          name="consent_request_layout_version"/>
      </FilterGroup>
      <Loader {...loaderProps}>
        <CmpAnalyticsDashboardContainer kpis={kpis} analytics={analytics}>
          <ConsentByAppTable as="app" icon="app"  {...analytics.dataByApp}/>
          <ConsentLayoutTab as="layout" icon="layout"
                            dataByLayout={analytics.dataByLayout}
                            dataByLayoutByDay={analytics.dataByLayoutByDay}
                            requestsByLayout={analytics.requestsByLayout}/>
        </CmpAnalyticsDashboardContainer>
      </Loader>
    </>
  )
}
